import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../components/modalDoctorSpecialist.css";

const ModalDoctorSpecialist = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  specialistObject,
}) => {
  const [specialistData, setSpecialistData] = useState(specialistObject);

  const closeModal = () => {
    setSpecialistData({
      doctor_specialist_id: "",
      doctor_specialist_name: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-doctor-specialist-container">
        <div className="modal-doctor-specialist-content">
          <header className="modal-doctor-specialist-header">
            <h2 className="modal-doctor-specialist-header-title">
              Tambah Poli
            </h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-doctor-specialist-main">
            <div className="form-group">
              <div className="input_title_label_container">
                <span className="input_title_label">Spesialis Baru</span>
              </div>
              <div className="input_specialist_name_field_container">
                <input
                  type="text"
                  value={
                    specialistData.doctor_specialist_name
                      ? specialistData.doctor_specialist_name
                      : ""
                  }
                  onChange={(e) =>
                    setSpecialistData({
                      ...specialistData,
                      doctor_specialist_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama spesialis"
                />
              </div>
            </div>
          </main>
          <footer className="modal-doctor-specialist-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = specialistData.doctor_specialist_id !== "";
                onSubmitData(specialistData, isEditData);
                setSpecialistData({
                  doctor_specialist_id: "",
                  doctor_specialist_name: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalDoctorSpecialist;
